import React, { useState } from 'react';
import {Outlet, Link, NavLink } from "react-router-dom";


const Header = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };
  return (
    <>
      {/* <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/blogs">Blogs</Link>
          </li>
          <li>
            <Link to="/moobeen">Moobeen</Link>
          </li>
        </ul>
      </nav> */}

      {/* <nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
    <a className="navbar-brand" href="#">Navbar</a>
    <button onClick={handleMenuToggle} className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}  id="navbarSupportedContent">
   
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
        <NavLink to="/" className='nav-link'  onClick={handleMenuToggle}>Home</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/blogs" className='nav-link'  onClick={handleMenuToggle}>Blogs</NavLink>
        </li>
        <li className="nav-item">

          <NavLink to="/moobeen" className='nav-link' onClick={handleMenuToggle}>Moobeen</NavLink>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Dropdown
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="#">Action</a></li>
            <li><a className="dropdown-item" href="#">Another action</a></li>
            <li><hr className="dropdown-divider"/></li>
            <li><a className="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>
        <li className="nav-item">
          <a className="nav-link disabled">Disabled</a>
        </li>
      </ul>
      <form className="d-flex">
        <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
        <button className="btn btn-outline-success" type="submit">Search</button>
      </form>
    </div>

  </div>
</nav> */}

<h2 className='text-center my-4 text-lg lg:text-4xl'>React Form Testing</h2>

      <Outlet />

      
    </>
  )
};

export default Header;